import React, { useState } from 'react';
import SideBar from "../../components/AdminDashboard/SideBar";
import { Link } from 'react-router-dom';
// import { FiArrowRight, FiEdit2, FiEyeOff } from 'react-icons/fi';

// ArticleCard Component
const ArticleCard = React.memo(({ article, onReadMore, onEdit, onUnpublish }) => {
  return (
    <div className="bg-white rounded-lg border border-[#EFEFEF] overflow-hidden flex flex-col h-[366px] w-full max-w-[324px] hover:shadow-lg transition-shadow duration-300">
      <div className="relative w-full h-[200px] bg-[#D9D9D9]">
        <img 
          src={article.image} 
          alt={article.title}
          className="w-full h-full object-cover rounded-t-lg"
          loading="lazy"
        />
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-md text-xs font-medium shadow-sm">
          {article.status}
        </div>
      </div>

      <div className="flex flex-col flex-1 p-3 gap-3">
        <h3 className="font-inter font-medium text-sm leading-[21px] text-[#3B3B3B] line-clamp-2 hover:text-[#0D924F] transition-colors">
          {article.title}
        </h3>

        <p className="font-inter font-normal text-[10px] leading-4 text-[#898989] line-clamp-3 flex-1">
          {article.description}
        </p>

        <div className="flex items-center justify-between pt-1 border-t border-[#F4F4F5]">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 bg-[#FAFAFA] rounded-full flex items-center justify-center border border-[#EFEFEF]">
              <div className="w-1.5 h-1.5 bg-[#3B3B3B] rounded-full"></div>
            </div>
            <span className="font-inter font-normal text-[10px] leading-4 text-[#3B3B3B] truncate max-w-[100px]">
              {article.source}
            </span>
          </div>
          
          <button 
            onClick={() => onReadMore(article.id)}
            className="flex items-center gap-1.5 group"
          >
            <span className="font-inter font-medium text-[10px] leading-4 text-[#006633] group-hover:text-[#004d26] transition-colors">
              Read More
            </span>
            {/* <FiArrowRight className="w-4 h-4 text-[#006633] group-hover:translate-x-0.5 transition-transform" /> */}
          </button>
        </div>
      </div>

      <div className="flex items-center gap-4 px-3 py-2 bg-[#FAFAFA] border-t border-[#F4F4F5]">
        <button 
          onClick={() => onUnpublish(article.id)}
          className="flex items-center justify-center gap-1.5 text-sm text-[#645D5D] hover:text-[#3B3B3B] hover:bg-gray-100 px-3 py-1 rounded transition-colors"
        >
          {/* <FiEyeOff className="w-4 h-4" /> */}
          Unpublish
        </button>
        <button 
          onClick={() => onEdit(article.id)}
          className="flex items-center justify-center gap-1.5 px-5 py-1 bg-[#1671D9] text-white rounded hover:bg-[#1258a8] transition-colors shadow-sm hover:shadow-md"
        >
          {/* <FiEdit2 className="w-4 h-4" /> */}
          Edit
        </button>
      </div>
    </div>
  );
});

// Navigation Tabs Component
const NavigationTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex flex-row items-center gap-3 w-full overflow-x-auto scrollbar-hide pb-1">
      {tabs.map((label, index) => (
        <button
          key={index}
          onClick={() => onTabChange(index)}
          className={`
            flex-shrink-0 flex justify-center items-center 
            px-6 md:px-8 py-2 rounded-full h-[35px]
            transition-all duration-200 ease-in-out
            hover:scale-105 active:scale-95
            ${activeTab === index 
              ? 'bg-[#0D924F] text-white shadow-md shadow-green-200' 
              : 'bg-white text-[#898989] border border-[#F4F4F5] hover:border-[#0D924F] hover:text-[#0D924F]'
            }
          `}
        >
          <span className="font-inter font-normal text-sm md:text-base leading-[19px] whitespace-nowrap">
            {label}
          </span>
        </button>
      ))}
    </div>
  );
};

function ViewPosts() {
  const [activeTab, setActiveTab] = useState(0);
  const [articles, setArticles] = useState([
    {
      id: 1,
      title: "Renewable firms hiring talent across levels amid expansion",
      description: "The renewable energy sector is experiencing significant growth, leading to increased hiring across all levels...",
      source: "Business Today",
      image: "/api/placeholder/300/200",
      status: "Published"
    },
    {
      id: 2,
      title: "AI and Machine Learning transforming healthcare industry",
      description: "Artificial Intelligence and Machine Learning are revolutionizing healthcare delivery...",
      source: "TechCrunch",
      image: "/api/placeholder/300/200",
      status: "Draft"
    },
    {
      id: 3,
      title: "Web development trends to watch in 2024",
      description: "Stay ahead of the curve with these emerging web development trends and technologies...",
      source: "Dev.to",
      image: "/api/placeholder/300/200",
      status: "Published"
    },
    {
      id: 4,
      title: "Data Science: The future of decision making",
      description: "How data science is reshaping business strategies and decision-making processes...",
      source: "Data Science Central",
      image: "/api/placeholder/300/200",
      status: "Draft"
    },
    {
      id: 5,
      title: "Cloud Computing and DevOps: A match made in heaven",
      description: "The synergy between cloud computing and DevOps is transforming software development...",
      source: "Cloud Native News",
      image: "/api/placeholder/300/200",
      status: "Published"
    },
    {
      id: 6,
      title: "Cybersecurity challenges in the remote work era",
      description: "As remote work becomes the norm, cybersecurity professionals face new challenges...",
      source: "Security Today",
      image: "/api/placeholder/300/200",
      status: "Draft"
    }
  ]);

  const tabs = [
    'All Posts',
    'Technology & Innovation',
    'Artificial Intelligence',
    'Web Development',
    'Data Science',
    'Cloud Computing',
    'Cybersecurity'
  ];

  const handleReadMore = (articleId) => {
    console.log('Read more:', articleId);
    // Navigate to article detail
  };

  const handleEdit = (articleId) => {
    console.log('Edit article:', articleId);
    // Open edit modal or navigate to edit page
  };

  const handleUnpublish = (articleId) => {
    console.log('Unpublish article:', articleId);
    // Toggle article status
    setArticles(prev => prev.map(article => 
      article.id === articleId 
        ? { ...article, status: article.status === 'Published' ? 'Draft' : 'Published' }
        : article
    ));
  };

  return (
    <div className="admin_history flex min-h-screen bg-[#F8F9FA]">
      {/* Sidebar */}
      <div className="sidebar_container flex-shrink-0">
        <SideBar />
      </div>

      {/* Main Content */}
      <div className="flex-1 ml-4 md:ml-8 lg:ml-12 p-4 md:p-6 lg:p-8">
        {/* Back Link */}
        <Link to="/ads">
          <div className="mt-4 md:mt-8 mb-6 md:mb-10 flex items-center gap-2 text-[24px] font-semibold text-[#101828] hover:text-[#0D924F] transition-colors">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 10.9993H7.14L10.77 6.6393C10.9397 6.43508 11.0214 6.1718 10.997 5.90738C10.9726 5.64295 10.8442 5.39904 10.64 5.2293C10.4358 5.05956 10.1725 4.9779 9.90808 5.00228C9.64365 5.02666 9.39974 5.15508 9.23 5.3593L4.23 11.3593C3.19568 12.4066 3.16556 12.4568 3.14 12.5093C3.14 12.5593 3.14 12.5893 3.07 12.6393C3.02467 12.754 3.00094 12.876 3 12.9993C3.00094 13.1226 3.02467 13.2446 3.07 13.3593C3.07 13.4093 3.07 13.4393 3.14 13.4893C3.16556 13.5418 3.19568 13.592 3.23 13.6393L8.23 19.6393C8.32402 19.7522 8.44176 19.843 8.57485 19.9052C8.70793 19.9674 8.85309 19.9995 9 19.9993C9.2337 19.9998 9.4601 19.9184 9.64 19.7693C9.7413 19.6854 9.825 19.5822 9.8863 19.4659C9.9477 19.3496 9.9855 19.2222 9.9975 19.0913C10.0096 18.9603 9.9957 18.8282 9.9567 18.7026C9.9176 18.577 9.8542 18.4603 9.77 18.3593L6.14 13.9993H19C19.2652 13.9993 19.5196 13.8939 19.7071 13.7064C19.8946 13.5189 20 13.2645 20 12.9993C20 12.7341 19.8946 12.4797 19.7071 12.2922C19.5196 12.1047 19.2652 11.9993 19 11.9993V10.9993Z" fill="currentColor"/>
            </svg>
            View Posts
          </div>
        </Link>

        {/* Navigation Tabs */}
        <div className="mb-8">
          <NavigationTabs 
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />
        </div>

        {/* Posts Grid */}
        <div className="border border-[#898989] rounded-t-xl overflow-hidden">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 p-6 bg-[#FAFAFA]">
            {articles.map((article) => (
              <ArticleCard
                key={article.id}
                article={article}
                onReadMore={handleReadMore}
                onEdit={handleEdit}
                onUnpublish={handleUnpublish}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewPosts;